import React, { useContext, useEffect, useState } from 'react'
import { Accordion, Card } from 'react-bootstrap';
import ConnUrls from '../../../../MyConns/Connections/ConnectURL';
import ImgAndTxtCARD from '../../../MySections/DTechComps/ImgAndTxtCARD';
import { HomePContext } from '../../../MyContexts/HomeP_Context';

const TabHPheaders = (props) => {
 

    const [homeP, setHomeP] = useContext(HomePContext);

    const [mainHead, setMainHead] = useState(homeP.mainHead);
    const [secondHead, setSecondHead] = useState(homeP.secondHead);

    useEffect(() => {


    }, [])
    const setTheMainHead = (e) => {
        homeP["mainHead"] = e.target.value;
        setMainHead(e.target.value);
    }


    const setTheSecondHead = (e) => {
        homeP["secondHead"] = e.target.value;
        setSecondHead(e.target.value);
    }



    return (
        <>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_6"}>כותרת ראשית</label>
                <span className={"explanation mediumst fullROw"}></span>
                <div className={"input-group"}>
                    <input type="text" className={"form-control"} id={"validationCustom1_17"} placeholder={"כותרת"} value={mainHead}
                        onChange={(e) => { setTheMainHead(e) }}
                    />

                </div>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_6"}>כותרת משנית</label>
                <span className={"explanation mediumst fullROw"}></span>
                <div className={"input-group"}>
                    <input type="text" className={"form-control"} id={"validationCustom1_17"} placeholder={"כותרת"} value={secondHead}
                        onChange={(e) => { setTheSecondHead(e) }}
                    />

                </div>
            </div>

        </>

    );
}

export default TabHPheaders;